/**
 * First-party proof that a Google Ads click ID reached the browser on this page load.
 * Fires GA4 event ad_landing_verified (register as Key event in GA4 Admin).
 * Loaded from theme.liquid head for all pages; no-op unless gclid/gbraid/wbraid or _gcl_aw.
 */
(function () {
  'use strict';

  var GT_SEND_TO = 'GT-T5P4FHD';

  function hasPaidClickId() {
    try {
      if (/[?&](gclid|gbraid|wbraid)=/i.test(window.location.search)) return true;
      return /(?:^|;\s*)_gcl_aw=/.test(document.cookie || '');
    } catch (e) {
      return false;
    }
  }

  if (!hasPaidClickId()) return;
  if (window.__ildAdLandingVerified) return;
  window.__ildAdLandingVerified = true;

  function fireVerified() {
    if (window.__ildAdLandingVerifiedFired) return;
    if (typeof gtag !== 'function') return;
    window.__ildAdLandingVerifiedFired = true;
    gtag('event', 'ad_landing_verified', {
      send_to: GT_SEND_TO,
      page_path: window.location.pathname,
      page_location: window.location.href,
      transport_type: 'beacon',
    });
  }

  try {
    localStorage.setItem(
      '_ild_last_ad_landing',
      JSON.stringify({
        t: Date.now(),
        path: window.location.pathname,
        search: window.location.search,
      })
    );
  } catch (e) {}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fireVerified, { once: true });
  } else {
    fireVerified();
  }
})();
